import { BASE_API } from "../utils/constants";

/** Helpers **/
const authHeader = (token) => ({
  Authorization: `Bearer ${token}`,
});

/* =======================
   EXPENSES
   ======================= */

export async function getExpensesApi(token, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_API}/api/finance/expenses/${query ? `?${query}` : ""}`;
    const res = await fetch(url, { headers: authHeader(token) });
    if (!res.ok) throw new Error("Error al cargar gastos");
    return await res.json();
  } catch (err) {
    throw err;
  }
}

export async function createExpenseApi(data, token) {
  try {
    const url = `${BASE_API}/api/finance/expenses/`;
    const params = {
      method: "POST",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function updateExpenseApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/finance/expenses/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function deleteExpenseApi(id, token) {
  try {
    const url = `${BASE_API}/api/finance/expenses/${id}/`;
    const params = { method: "DELETE", headers: authHeader(token) };
    const res = await fetch(url, params);
    if (!res.ok) throw new Error("No se pudo eliminar el gasto");
    return true;
  } catch (err) {
    throw err;
  }
}

/* =======================
   EXPENSE CATEGORIES
   ======================= */

export async function getExpenseCategoriesApi(token, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_API}/api/finance/expense-categories/${query ? `?${query}` : ""}`;
    const res = await fetch(url, { headers: authHeader(token) });
    if (!res.ok) throw new Error("Error al cargar categorías de gasto");
    return await res.json();
  } catch (err) {
    throw err;
  }
}

export async function createExpenseCategoryApi(data, token) {
  try {
    const url = `${BASE_API}/api/finance/expense-categories/`;
    const params = {
      method: "POST",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function updateExpenseCategoryApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/finance/expense-categories/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function deleteExpenseCategoryApi(id, token) {
  try {
    const url = `${BASE_API}/api/finance/expense-categories/${id}/`;
    const params = { method: "DELETE", headers: authHeader(token) };
    const res = await fetch(url, params);
    if (!res.ok) throw new Error("No se pudo eliminar la categoría");
    return true;
  } catch (err) {
    throw err;
  }
}


